import React, { createContext, useState, useContext, useEffect } from 'react';
import { checkAuth } from '../services/API';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const updateUser = async (userData) => {
        setUser(userData);
    };

    const logout = async () => {
        await updateUser(null);
    };

    const verifyAuth = async () => {
        if (window.location.pathname.startsWith('/auth/token')) {
            setLoading(false);
            return;
        }

        try {
            const response = await checkAuth();

            if (response.success) {
                await updateUser(response.data);
            } else {
                await logout();
            }
        } catch (error) {
            setUser(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        verifyAuth();
    }, []);

    return (
        <AuthContext.Provider value={{
            user,
            setUser: updateUser,
            loading,
            reloadUser: verifyAuth,
            logout
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};